$(document).ready(function () {
    $(document).on("click", ".addTo__cart", function (e) {
        e.preventDefault();
        if ($(this).hasClass("btn_disabled")) return;

        var $form = $(this).closest("form.single__product-form");
        if (!$form.length) {
            $form = $(".single__product-form").first();
        }
        if (!$form.length) return;

        var formData = $form.serialize();
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: formData,
            success: function (data) {
                if($("body").data("b2b") == true){
                   
                    var img = data.image;
                    var title = data.product_title;
                    var qty = data.quantity;
                    $('.atc-notification-modal__title').html("<h2>Successfully added to cart</h2>");
                    $(".atc-noti-img").html("<img src='"+img+"' alt='"+title+"' />");
                    $(".atc-noti-title").html("<h3>"+title+"</h3>");
                    $(".atc-noti-qty").html("<p>Qty: <span>"+qty+"</span></p>");
                    $(".atc-notification-modal").fadeIn();
                    // Only fade out if mouse is not hovering over the modal
                    
                    setTimeout(function() {
                        // If still hovering after 3s, set up mouseleave handler
                        if ($(".atc-notification-modal").is(":hover")) {
                            $(".atc-notification-modal").one("mouseleave", function() {
                                setTimeout(function() {
                                    $(".atc-notification-modal").fadeOut();
                                    setTimeout(function() {
                                        $(".atc-noti-img, .atc-noti-title,.atc-noti-qty, .atc-notification-modal__title").html('');
                                    }, 1000);
                                }, 2000);
                            });
                        } else {
                            // Already not hovering, handled by the fadeOut above
                            setTimeout(function() {
                                $(".atc-notification-modal").fadeOut();
                            }, 1000);
                            setTimeout(function() {
                                $(".atc-noti-img, .atc-noti-title,.atc-noti-qty, .atc-notification-modal__title").html('');
                            }, 2000);
                        }
                    }, 6000);

                    
                } else {
                    showCartDrawer('b2c');
                    sectionRendering();
                }
            },
            error: function (err) {
                console.log(err);
            },
        });

    });

});



function sectionRendering() {
    if($(".page-cart").length > 0 ){
        fetch("?section_id=main-cart")
            .then((res) => res.text())
            .then((data) => {
                var cart__html = $(data);
                var render__html = $(".cart-drawer__wrapper", cart__html);
                $(".cart-drawer__wrapper").replaceWith(render__html);
            });
       
    } else {
        fetch("?section_id=cart-drawer")
            .then((res) => res.text())
            .then((data) => {
                var cart__html = $(data);
                var render__html = $(".cart-drawer__wrapper", cart__html);
                $(".cart-drawer__wrapper").replaceWith(render__html);
            });
    }

    fetch("?section_id=header")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".header__cart", cart__html);
            $(".header__cart").replaceWith(render__html);
        });


}


function increment(event, el) {
    event.preventDefault();
    var input = el.previousElementSibling;
    var value = parseInt(input.value);
    value = isNaN(value) ? 0 : value
    value++;
    input.value = value;
    changeQuantity(input)
}

function decrement(event, el) {
    event.preventDefault();
    var input = el.nextElementSibling;
    var value = parseInt(input.value);
    if (value > 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
        changeQuantity(input)
    }
}

function changeQuantity(input) {

    var quantity = $(input).val();
    var data_line = $(input).attr("data-line");
    var data = {
        "line": data_line,
        "quantity": quantity
    };
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
        
            sectionRendering()
        },
        error: function (err) {
            console.log("Error from quantity update")
        }
    })


}


function removeItem(event, el) {

    event.preventDefault();
    var data_key = $(el).attr("data-key");
    if (!data_key) return;
    var deleteData = {
        "id": data_key,
        "quantity": 0
    };

    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: deleteData,
        success: function (data) {
           
            sectionRendering();
        }
    })
}